import React, { useContext, useState } from "react";
import {
  Button,
  TextField,
  Container,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
  Box,
  Paper,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { AuthContext } from "../../context/authContext";
// import OtpDialog from "../../components/otp/OtpDialog";
import ChakraImageComponent from "../../components/ChakraImageComponent";
import logo from "../../assets/logo1.png";
import { useForm, SubmitHandler } from "react-hook-form";
import { FcGoogle } from "react-icons/fc";
interface IFormInput {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  // const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  // const [submittedEmail, setSubmittedEmail] = useState("");
  const navigate = useNavigate();

  const { login } = useContext(AuthContext);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleGoogleLogin = () => {
    window.location.href = `${import.meta.env.VITE_API_URL}/v0/api/auth/google`;
  };

  // Initialize React Hook Form
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<IFormInput>();

  const onSubmit: SubmitHandler<IFormInput> = async (data) => {
    try {
      await login(data);

      navigate("/");
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  // const handleVerifyOtp = async (otp: string) => {
  //   try {
  //     await verifyOtpAndLogin({ email: submittedEmail, otp });
  //     return true;
  //   } catch (error) {
  //     console.error("OTP verification failed:", error);
  //     return false;
  //   }
  // };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <Container
      maxWidth="lg"
      sx={{ display: "flex", minHeight: "100vh", alignItems: "center" }}
    >
      <Grid
        container
        spacing={12}
        sx={{
          height: "100%",
          display: "flex",
        }}
      >
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: isSmallScreen ? "none" : "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
            height: "100vh",
          }}
        >
          <ChakraImageComponent />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
          }}
        >
          <Paper
            elevation={10}
            sx={{
              width: "100%",
              maxWidth: "450px",
              borderRadius: theme.spacing(3),
              padding: theme.spacing(4),
              background: "linear-gradient(145deg, #f0f4f8 0%, #e6eaf0 100%)",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "-50px",
                left: "-50px",
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #bb0000 0%, #bb0000 100%)",
                opacity: 0.1,
              }}
            />
            <Box
              sx={{
                textAlign: "center",
                marginBottom: theme.spacing(3),
              }}
            >
              <img
                src={logo}
                alt="logo"
                style={{
                  width: "200px",
                  height: "200px",
                  marginBottom: theme.spacing(2),
                }}
              />
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.text.secondary,
                  marginBottom: theme.spacing(1),
                }}
              >
                Welcome Back
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Sign in to continue to your account
              </Typography>
            </Box>

            <Box
              component="form"
              onSubmit={handleSubmit(onSubmit)}
              sx={{ width: "100%" }}
              noValidate
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                autoComplete="email"
                autoFocus
                variant="outlined"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value:
                      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i,
                    message: "Invalid email address",
                  },
                })}
                error={!!errors.email}
                helperText={errors.email ? errors.email.message : ""}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: theme.spacing(2),
                  },
                }}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                // name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                variant="outlined"
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 6,
                    message: "Password must be at least 6 characters",
                  },
                })}
                error={!!errors.password}
                helperText={errors.password ? errors.password.message : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: theme.spacing(2),
                  },
                }}
              />
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: theme.spacing(1),
                }}
              >
                <Link
                  to="/forgot-password"
                  style={{
                    textDecoration: "none",
                    color: "#bb0000",
                    fontWeight: 500,
                  }}
                >
                  Forgot Password?
                </Link>
              </Box>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={isSubmitting}
                sx={{
                  mt: 2,
                  mb: 2,
                  borderRadius: theme.spacing(2),
                  padding: theme.spacing(1.5),
                  background:
                    "linear-gradient(45deg, #bb0000 0%, #bb0000 100%)",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.02)",
                    boxShadow: "0 6px 8px rgba(0,0,0,0.15)",
                  },
                }}
              >
                {isSubmitting ? "Logging in..." : "Login"}
              </Button>
              <Button
                fullWidth
                variant="outlined"
                onClick={handleGoogleLogin}
                startIcon={<FcGoogle />}
                sx={{
                  mt: 1,
                  mb: 1,
                  borderRadius: theme.spacing(2),
                  padding: theme.spacing(1.5),
                  border: "2px solid #bb0000",
                  color: "#bb0000",
                  fontWeight: 600,
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                    backgroundColor: "#bb0000",
                    color: "#fff",
                  },
                }}
              >
                Login with Google
              </Button>
              <Typography
                variant="body2"
                align="center"
                sx={{
                  mt: 2,
                  color: theme.palette.text.secondary,
                }}
              >
                Don't have an account?{" "}
                <Link
                  to="/register"
                  style={{
                    textDecoration: "none",
                    color: "#bb0000",
                    fontWeight: 600,
                  }}
                >
                  Register Now
                </Link>
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      {/* <OtpDialog
        open={otpDialogOpen}
        onClose={() => setOtpDialogOpen(false)}
        onVerify={handleVerifyOtp}
        onResend={handleSubmit(onSubmit)}
      /> */}
    </Container>
  );
};

export default Login;
